import type { PipelineStep } from './template-generation.types';

export const TEMPLATE_GENERATION_AGENT_ID = 'template-generation-v1' as const;

/* eslint-disable i18next/no-literal-string -- step ids mirrored by the workflow's sub-agents */
export const PIPELINE_STEPS: readonly PipelineStep[] = [
  { id: 'reading-files', label: 'Reading files' },
  { id: 'generating-sections', label: 'Generating template sections' },
  { id: 'saving-template', label: 'Saving template', feOnly: true },
] as const;
/* eslint-enable i18next/no-literal-string */
